import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import InstrumentenPage from "@/pages/InstrumentenPage.vue";
import KalibratieoproepPage from "@/pages/KalibratieoproepPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/kalibratieoproep",
    name: "Kalibratieoproep",
    component: KalibratieoproepPage,
  },
  {
    path: "/instrumenten",
    name: "Instrumenten",
    component: InstrumentenPage,
  },
  {
    path: "/",
    redirect: "/kalibratieoproep",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
